<template>
<div class="container">
    <div class="row">
        <b-button variant="primary" size="sm" class="mr-2" @click="addMeta"><i class="fa fa-tasks"></i> Visualizar Metas</b-button>
        <b-button variant="primary" size="sm" class="mr-2" href="/adm/bonificacao"><i class="fas fa-arrow-alt-circle-right"></i> Pedidos Bonificados</b-button>
    </div>
    <h3 class="mt-3">Indicadores - Pedidos Bonificados</h3>
    <b-card>
        <b-col lg="4">
            <b-form-group label-for="filter-input" label-size="sm" class="mb-0">
                <b-input-group>
                    <b-form-input size="sm" id="filter-input" v-model="filter" type="search" placeholder="Buscar Distribuidor"></b-form-input>
                    <b-input-group-append>
                        <b-button size="sm" :disabled="!filter" @click="filter = ''">Limpar</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-table class="mt-1" :items="listpedidos" :fields="fields" show-empty hover @filtered="onFiltered" :current-page="currentPage" :per-page="perPage" :filter="filter" :filter-included-fields="filterOn" :sort-direction="sortDirection" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
        </b-table>
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm" class="my-0"></b-pagination>
    </b-card>
</div>
</template>

<script>
import moment from 'moment';
import vSelect from "vue-select";
export default {
    components: {
        vSelect
    },
    data() {
        return {
            totalRows: 1,
            currentPage: 1,
            perPage: 30,
            sortBy: 'status',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            fields: [{
                    key: 'codigo',
                    label: 'Código',
                },
                {
                    key: 'nome',
                    label: 'Distribuidor',
                    sortField: 'codigo',

                },
                {
                    key: 'total',
                    label: 'Valor do Pedido',
                    class: "text-center",
                    sortable: true,
                    formatter: (value) => {
                        return value ? 'R$ ' + parseFloat(value).toFixed(2).toString().replace(".", ",") : ""
                    },
                },
                {
                    key: 'credito',
                    label: 'Valor do Crédito',
                    class: "text-center",
                    sortable: true,
                    formatter: (value) => {
                        return value ? 'R$ ' + parseFloat(value).toFixed(2).toString().replace(".", ",") : ""
                    },
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    class: "text-center",
                },
                {
                    key: 'data_expira',
                    label: 'Expira em',
                    class: "text-center",
                    sortable: true,
                    formatter: (value) => {
                        return moment(value).format("DD/MM/YYYY")
                    },
                },
            ],
            listpedidos: [],
            filtro: '',
        }
    },

    methods: {
        onFiltered(distribuidor) {
            this.totalRows = distribuidor.length
            this.currentPage = 1
        },

        addMeta() {
            $('.loading').show();
            window.location.href = '/adm/metas/';
        },

        getLoad() {
            var vm = this;
            $('.loading').show();
            axios.get('/adm/metas/topclasseg', {}).then(function (response) {
                vm.listpedidos = response.data;
                vm.totalRows = vm.listpedidos.length
                $('.loading').hide();

            }).catch(function (error) {
                console.log(error);
                $('.loading').hide();
            });

        },

    },

    mounted() {
        this.getLoad();
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/adm_metas/Metas.vue